export default import.meta.ROLLUP_FILE_URL_jjjeI5GvH1mJV_csb8O65w